<template>
  <div class="echarts" :id="schema.model" :style="this.schema.graphic.style"></div>
</template>

<script>
import * as echarts from 'echarts';
import { abstractField } from 'vue-form-generator';

export default {
  mixins: [abstractField],

  mounted() {
    const myChart = echarts.init(document.getElementById(this.schema.model));

    myChart.setOption(this.schema.graphic.options);
  }
};
</script>
